import { Check } from 'lucide-react';

// Small, self-looping UI mockups used only on the Point of Sale and AI
// Assistant showcase rows. Pure CSS keyframe loops (no video, no JS timers) —
// clearly a simplified illustration of the flow, not a real product capture.

export const PosWalkthrough = () => (
  <div className="wl-feature-demo" data-testid="welcome-walkthrough-pos" aria-hidden="true">
    <div className="wl-mini-demo-head"><span className="wl-mini-demo-dot" /> Illustrative walkthrough</div>
    <div className="wl-mini-cart">
      <span className="wl-mini-scanline" />
      <div className="wl-mini-row wl-mini-row-1"><span>Panadol Extra x2</span><span>GHS 18.00</span></div>
      <div className="wl-mini-row wl-mini-row-2"><span>Amoxicillin 500mg</span><span>GHS 24.00</span></div>
      <div className="wl-mini-row wl-mini-row-3"><span>ORS Sachet</span><span>GHS 6.00</span></div>
    </div>
    <div className="wl-mini-total-wrap">
      <span className="wl-mini-total wl-mini-total-0">GHS 0.00</span>
      <span className="wl-mini-total wl-mini-total-1">GHS 18.00</span>
      <span className="wl-mini-total wl-mini-total-2">GHS 42.00</span>
      <span className="wl-mini-total wl-mini-total-3">GHS 48.00</span>
    </div>
    <div className="wl-mini-status"><Check size={13} /> Payment received</div>
  </div>
);

export const AiWalkthrough = () => (
  <div className="wl-feature-demo" data-testid="welcome-walkthrough-ai" aria-hidden="true">
    <div className="wl-mini-demo-head"><span className="wl-mini-demo-dot" /> Illustrative walkthrough</div>
    <div className="wl-mini-chat">
      <div className="wl-mini-bubble wl-mini-bubble-q">Any interaction with Amoxicillin + Warfarin?</div>
      <div className="wl-mini-typing"><span /><span /><span /></div>
      <div className="wl-mini-bubble wl-mini-bubble-a">Moderate interaction — monitor INR closely. Flagged for pharmacist review.</div>
    </div>
  </div>
);
